// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__f5yR5","children-wrapper":"style_children-wrapper__faUHU","debug":"style_debug__glU+e"};